import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

// ********************* Update ****************************
const buildUpdateOtherContractHolderFact = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		factId,
		entityId,
		input,
		store
	}) {
		const query = gql`
			mutation updateOtherContractHolderFact(
				$policyId: String!
				$endorsementId: String
				$factId: String!
				$entityId: String!
				$input: updateFactInput!
			) {
				updateOtherContractHolderFact(
					policyId: $policyId
					endorsementId: $endorsementId
					factId: $factId
					entityId: $entityId
					input: $input
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, factId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.updateOtherContractHolderFact, store)
		return {
			status: res?.data?.updateOtherContractHolderFact?.status,
			id: res?.data?.updateOtherContractHolderFact?.createdStatus?.id
		}
	}
}
const buildUpdateOtherContractHolderIndividual = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, input, store }) {
		const query = gql`
			mutation updateOtherContractHolder(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
				$individualInput: updateContractIndividualInput
			) {
				updateOtherContractHolder(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
					individualInput: $individualInput
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = {
			policyId,
			endorsementId,
			entityId,
			individualInput: input
		}
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.updateOtherContractHolder, store)
		return {
			status: res?.data?.updateOtherContractHolder?.status,
			id: res?.data?.updateOtherContractHolder?.createdStatus?.id
		}
	}
}
const buildUpdateOtherContractHolderCompany = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, input, store }) {
		const query = gql`
			mutation updateOtherContractHolder(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
				$input: updateContractCompanyInput
			) {
				updateOtherContractHolder(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
					companyInput: $input
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.updateOtherContractHolder, store)
		return {
			status: res?.data?.updateOtherContractHolder?.status,
			id: res?.data?.updateOtherContractHolder?.createdStatus?.id
		}
	}
}
const buildUpdateOtherContractHolderAddress = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		addressId,
		entityId,
		input,
		store
	}) {
		const query = gql`
			mutation updateOtherContractHolderAddress(
				$policyId: String!
				$endorsementId: String
				$addressId: String!
				$entityId: String!
				$input: updateAddressInput!
			) {
				updateOtherContractHolderAddress(
					policyId: $policyId
					endorsementId: $endorsementId
					addressId: $addressId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, addressId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(
			res?.errors,
			res?.data?.updateOtherContractHolderAddress,
			store
		)
		return {
			status: res?.data?.updateOtherContractHolderAddress?.status,
			id: res?.data?.updateOtherContractHolderAddress?.createdStatus?.id
		}
	}
}
const buildUpdateOtherContractHolderContact = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		contactId,
		entityId,
		input,
		store
	}) {
		const query = gql`
			mutation updateOtherContractHolderContact(
				$policyId: String!
				$endorsementId: String
				$contactId: String!
				$entityId: String!
				$input: updateContactInput!
			) {
				updateOtherContractHolderContact(
					policyId: $policyId
					endorsementId: $endorsementId
					contactId: $contactId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, contactId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(
			res?.errors,
			res?.data?.updateOtherContractHolderContact,
			store
		)
		return {
			status: res?.data?.updateOtherContractHolderContact?.status,
			id: res?.data?.updateOtherContractHolderContact?.createdStatus?.id
		}
	}
}
const buildUpdateOtherContractHolderIdentity = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		identityId,
		entityId,
		input,
		store
	}) {
		const query = gql`
			mutation updateOtherContractHolderIdentity(
				$policyId: String!
				$endorsementId: String
				$identityId: String!
				$entityId: String!
				$input: updateIdentityInput!
			) {
				updateOtherContractHolderIdentity(
					policyId: $policyId
					endorsementId: $endorsementId
					identityId: $identityId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, identityId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(
			res?.errors,
			res?.data?.updateOtherContractHolderIdentity,
			store
		)
		return {
			status: res?.data?.updateOtherContractHolderIdentity?.status,
			id: res?.data?.updateOtherContractHolderIdentity?.createdStatus?.id
		}
	}
}

// ************************** Add ****************************************
const buildAddOtherContractHolderFact = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, input, store }) {
		const query = gql`
			mutation addOtherContractHolderFact(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
				$input: addFactInput!
			) {
				addOtherContractHolderFact(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
					input: $input
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addOtherContractHolderFact, store)
		return {
			status: res?.data?.addOtherContractHolderFact?.status,
			id: res?.data?.addOtherContractHolderFact?.createdStatus?.id
		}
	}
}

const buildAddOtherContractHolderAddress = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, input, store }) {
		const query = gql`
			mutation addOtherContractHolderAddress(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
				$input: addressInput!
			) {
				addOtherContractHolderAddress(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addOtherContractHolderAddress, store)
		return {
			status: res?.data?.addOtherContractHolderAddress?.status,
			id: res?.data?.addOtherContractHolderAddress?.createdStatus?.id
		}
	}
}
const buildAddOtherContractHolderContact = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, input, store }) {
		const query = gql`
			mutation addOtherContractHolderContact(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
				$input: addContactInput!
			) {
				addOtherContractHolderContact(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addOtherContractHolderContact, store)
		return {
			status: res?.data?.addOtherContractHolderContact?.status,
			id: res?.data?.addOtherContractHolderContact?.createdStatus?.id
		}
	}
}
const buildAddOtherContractHolderIdentity = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, input, store }) {
		const query = gql`
			mutation addOtherContractHolderIdentity(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
				$input: addIdentityInput!
			) {
				addOtherContractHolderIdentity(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
					input: $input
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, entityId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addOtherContractHolderIdentity, store)
		return {
			status: res?.data?.addOtherContractHolderIdentity?.status,
			id: res?.data?.addOtherContractHolderIdentity?.createdStatus?.id
		}
	}
}

// ***************************** Remove ***********************************
const buildRemoveOtherContractHolderFact = function(errorHandler) {
	return async function({ policyId, endorsementId, factId, entityId, store }) {
		const query = gql`
			mutation removeOtherContractHolderFact(
				$policyId: String!
				$endorsementId: String
				$factId: String!
				$entityId: String!
			) {
				removeOtherContractHolderFact(
					policyId: $policyId
					endorsementId: $endorsementId
					factId: $factId
					entityId: $entityId
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, factId, entityId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.removeOtherContractHolderFact, store)
		return {
			status: res?.data?.removeOtherContractHolderFact?.status,
			id: res?.data?.removeOtherContractHolderFact?.createdStatus?.id
		}
	}
}

const buildRemoveOtherContractHolderAddress = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		addressId,
		entityId,
		store
	}) {
		const query = gql`
			mutation removeOtherContractHolderAddress(
				$policyId: String!
				$endorsementId: String
				$addressId: String!
				$entityId: String!
			) {
				removeOtherContractHolderAddress(
					policyId: $policyId
					endorsementId: $endorsementId
					addressId: $addressId
					entityId: $entityId
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, addressId, entityId }
		const res = await api({ query, variables })
		errorHandler(
			res?.errors,
			res?.data?.removeOtherContractHolderAddress,
			store
		)
		return {
			status: res?.data?.removeOtherContractHolderAddress?.status,
			id: res?.data?.removeOtherContractHolderAddress?.createdStatus?.id
		}
	}
}
const buildRemoveOtherContractHolderContact = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		contactId,
		entityId,
		store
	}) {
		const query = gql`
			mutation removeOtherContractHolderContact(
				$policyId: String!
				$endorsementId: String
				$contactId: String!
				$entityId: String!
			) {
				removeOtherContractHolderContact(
					policyId: $policyId
					endorsementId: $endorsementId
					contactId: $contactId
					entityId: $entityId
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, contactId, entityId }
		const res = await api({ query, variables })
		errorHandler(
			res?.errors,
			res?.data?.removeOtherContractHolderContact,
			store
		)
		return {
			status: res?.data?.removeOtherContractHolderContact?.status,
			id: res?.data?.removeOtherContractHolderContact?.createdStatus?.id
		}
	}
}
const buildRemoveOtherContractHolderIdentity = function(errorHandler) {
	return async function({
		policyId,
		endorsementId,
		identityId,
		entityId,
		store
	}) {
		const query = gql`
			mutation removeOtherContractHolderIdentity(
				$policyId: String!
				$endorsementId: String
				$identityId: String!
				$entityId: String!
			) {
				removeOtherContractHolderIdentity(
					policyId: $policyId
					endorsementId: $endorsementId
					identityId: $identityId
					entityId: $entityId
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, identityId, entityId }
		const res = await api({ query, variables })
		errorHandler(
			res?.errors,
			res?.data?.removeOtherContractHolderIdentity,
			store
		)
		return {
			status: res?.data?.removeOtherContractHolderIdentity?.status,
			id: res?.data?.removeOtherContractHolderIdentity?.createdStatus?.id
		}
	}
}

// ****************** Remove section **********************
const buildRemoveOtherContractHolder = function(errorHandler) {
	return async function({ policyId, endorsementId, entityId, store }) {
		const query = gql`
			mutation removeOtherContractHolder(
				$policyId: String!
				$endorsementId: String
				$entityId: String!
			) {
				removeOtherContractHolder(
					policyId: $policyId
					endorsementId: $endorsementId
					entityId: $entityId
				) {
					errors
					status
					createdStatus {
						id
					}
				}
			}
		`
		const variables = { policyId, endorsementId, entityId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.removeOtherContractHolder, store)
		return {
			status: res?.data?.removeOtherContractHolder?.status,
			id: res?.data?.removeOtherContractHolder?.createdStatus?.id
		}
	}
}

export {
	buildUpdateOtherContractHolderAddress,
	buildUpdateOtherContractHolderCompany,
	buildUpdateOtherContractHolderContact,
	buildUpdateOtherContractHolderFact,
	buildUpdateOtherContractHolderIdentity,
	buildUpdateOtherContractHolderIndividual,
	buildAddOtherContractHolderAddress,
	buildAddOtherContractHolderContact,
	buildAddOtherContractHolderFact,
	buildAddOtherContractHolderIdentity,
	buildRemoveOtherContractHolderAddress,
	buildRemoveOtherContractHolderContact,
	buildRemoveOtherContractHolderFact,
	buildRemoveOtherContractHolderIdentity,
	buildRemoveOtherContractHolder
}
